import { Component, Fragment } from 'react';
import EditButton from 'Components/Table/EditButton';
import DeleteButton from 'Components/Table/DeleteButton';
import { ReactComponent as Add } from 'assets/images/svg/Frame (21).svg';
import Pagination from 'Components/Pagination/index';
import DataTable from 'Container/DataTable/DataTableContainer';
import formUrlParams from 'Helpers/urlform';
import { debounce } from 'lodash';
import dateFormat from 'dateformat';
import {  convertUTCTOLocalTimeStamp } from 'Components/Common/TimeStamp';
import { CSVLink } from 'react-csv';
import { ModuleActions } from 'Constants/Modules.constants';
import { tableConstants } from 'Constants';

/**
 * @file Team Component
 * Admin can view, update and delete the team details
 * @module 8.Team
 * @extends Component
 */

class TeamBroadcast extends Component {
  constructor(props) {
    super(props);
    const model = {
      headers: [
        {
          className: tableConstants.SMALL_GRID_NAME_WIDTH,
          title: 'Team Name',
          chooseOption: {
            name: 'teamNameSearch' /* API param name */,
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          combineapidata: [ 'teamName', 'image' ],
          accessor: 'teamName' /* API response */,
          cell: {
            type: 'image-with-name',
          },
          sortOption: true,
          tooltip: true
        },
        {
          // className:tableConstants.SMALL_GRID_NAME_WIDTH,
          title: 'About Team',
          accessor: 'aboutTeam',
          chooseOption: {
            name: 'aboutTeamSearch' /* API param name */,
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          cell: function (rowDetails) {
            const { index, content } = rowDetails;
            return (
              // <td key={ index } className={ tableConstants.SMALL_GRID_NAME_WIDTH }>
              <td key={ index }>
                <div className='data_tooltip'>
                  <span>{content}</span>
                </div>
              </td>
            );
          },
          sortOption: true,
        },
        {
          className: tableConstants.DATE_RANGE_WIDTH,
          title: 'Created Date',
          chooseOption: {
            name: 'createdDateSearch',
            Component: 'DateTimeRangeComponent',
            dispatchFunction: this.handleDateSearch,
          },
          accessor: 'createdAt',
          cell: function (rowDetails) {
            const { index, content } = rowDetails;
            const val = content && content.replace('T',' ')
            const time = content && convertUTCTOLocalTimeStamp(val)
            return (
              <td key={ index } className={ tableConstants.DATE_RANGE_WIDTH }>
                {content && dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ')}
              </td>
            );
          },
          //sortOption: true,
        },
        /* {
          title: 'Users Count',
          accessor: 'teamMembersCount',
          sortOption: true,
        }, */
        /* {
          title: 'Status',
          chooseOption: {
            name: 'statusSearch',
            Component: 'DropDown',
            DropdownText: 'All',
            dispatchFunction: this.debounceEvent(this.handleSearch, 500),
            optionRender: this.createStatus,
          },
          accessor: 'isActive',
          cell: function (rowDetail) {
            const { content, index } = rowDetail;
            const status =
              content === 1 ? (
                <Fragment>
                  <span className='active'></span>Enable
                </Fragment>
              ) : (
                <Fragment>
                  <span className='inactive'></span>Disable
                </Fragment>
              );
            return <td key={ index }>{status}</td>;
          },
          //sortOption: true,
        }, */
        {
          className: 'action',
          title: 'Action',
          accessor: 'id',
          cell: (rowDetail) => {
            const { index, id, rowIdx, profile, ...rest } = rowDetail;
            const permission = profile && profile.Team;
            return (
              <td key={ index } data-row={ rowIdx } className='action'>
                { permission && !permission[ ModuleActions.edit ] && !permission[ ModuleActions.delete ] && 'N/A' }
                { permission && permission[ ModuleActions.edit ] && <EditButton
                  id={ id }
                  { ...rest }
                  getActiveEditData={ this.getActiveEditData }
                  editClass='editteam'
                  checkPermission={ permission && permission[ ModuleActions.edit ] }
                /> }
                { permission && permission[ ModuleActions.delete ] && <DeleteButton
                  remainningRecords={ this.props.team.length }
                  deleteActionListener={ this.props.deleteTeam }
                  activeQuery={ this.state.filtered }
                  id={ id }
                  currentPage={ this.props.currentPage }
                  checkPermission={ permission && permission[ ModuleActions.delete ] }
                /> }
              </td>
            );
          },
        },
      ],
      filtered: [],
      responseArray: [],
      pageLimit: 10,
      permission: true,
      fromDate: '',
      toDate: '',
      exportTeamData: '',
      activeSort: {},
    };
    this.state = model;
  }

  /**
   * @event componentDidMount
   * @summary API call to fetch team  details
   * @return {Object} return team object
   */

  componentDidMount() {
    this.props.fetchTeam();
    this.props.exportTeam();
  }

  getActiveEditData = (data) => {
    this.props.history.push(`/broadcast/team/editteam/${ data.id }`);
  };

  /**
   * @method formUrlParams
   * @param {name} name - Query string name
   * @param {value} value - Query string value
   * @param {rest} rest - Rest object except name and value
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
        updatedFilter = [
          ...this.state.filtered,
          activeSort
        ]
      }
      this.props.fetchTeam(updatedFilter);
      this.props.exportTeam(updatedFilter);
    });
  };

  /**
   * @method sortTable
   * @summary sort for view data
   * @param {name} sortAttribite - Query string name
   * @return { function } formUrlSort
   */
  sortTable = (sortAttribite) => {
    const { activeSort } = this.state
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.setState({
      activeSort: { id: sortAttribite, value: sortType },
    }, () => {
      this.formUrlSort();
    })
  }

  /**
   * @method formUrlSort
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */
  formUrlSort = () => {
    const updatedFilter = [
      ...this.state.filtered,
      this.state.activeSort
    ]
    this.props.fetchTeam(updatedFilter);
    this.props.exportTeam(updatedFilter);
  }

  /**
   * @method handleSearch
   * @summary set the  state
   * @param {event} event - React onChange event
   * @return { function } formUrlParams
   */
  handleSearch = (event) => {
    const { name, value } = event.target;
    this.formUrlParams(name, value);
  };

  handleDateSearch = (data) => {
    for (const [ key, value ] of Object.entries(data)) {
      this.formUrlParams(key, value);
    }
  };

  /**
   * @method hanldeAddAdmin
   * @summary open admin popup based click event
   * @return {none} undefined
   */

  hanldeAddTeam = () => {
    this.props.history.push(`/broadcast/team/addteam`);
  };

  /**
   * @method setPageLimit
   * @summary set page limit for view data per page
   * @param {name} name - Query string name
   * @param {value} value - Query string value
   * @return { function } formUrlParams
   */

  setPageLimit = (name, value) => {
    this.formUrlParams(name, value, { pageLimit: value });
  };

  createStatus = () => {
    const statusArray = [ 'Disable', 'Enable' ];
    return statusArray.map((admin, index) => {
      return (
        <option key={ index } value={ index }>
          {admin}
        </option>
      );
    });
  };
  /**
   * @method debounceEvent
   * @summary used to delay the event for some limit
   * @param {event} event - React onChange event
   * @return { function } debouncedEvent
   */
  debounceEvent(...args) {
    this.debouncedEvent = debounce(...args);
    return (e) => {
      e.persist();
      return this.debouncedEvent(e);
    };
  }

  updateActiveQuery = (updatedpagination) => {
    this.setState({
      filtered: [ ...this.state.filtered, ...updatedpagination ],
    });
  };

  render() {
    const { currentPage, totalRecords, team, profile, loading, exportTeamData } = this.props;
    const Permission = profile && profile.Team;

    return (
      <Fragment>
        <div className='grid pageContainer_inner'>
          <div className='heading-block gap-10'>
            <div className='block_flex'>
              <h4> Team Broadcast</h4>
            </div>
            <div className='block_flex'>
              { exportTeamData && exportTeamData.length !== 0 && <CSVLink
                  data = { exportTeamData }
                  filename = { 'Team Details.csv' }
                  className = 'btn btn_green'
                  onClick={ () => {
                    console.log('Export Data'); // Your click handling logic
                  } }
                >
                  Export To CSV
                </CSVLink>
              }
            
              {Permission && Permission[ ModuleActions.create ] && (
                <button className='btn btn_primary' onClick={ this.hanldeAddTeam }>
                  <Add />
                  New Team
                </button>
              )}
            </div>
          </div>
          <div className='responsive-table ctTableBox'>
            <DataTable
              headers={ this.state.headers }
              tableClassName ='col-s'
              data={ team }
              noData='No records!'
              loading={ loading }
              sortTable={ this.sortTable }
              activeSort={ this.state.activeSort }
            />
            <Pagination
              handleClick={ this.formUrlParams }
              totalRecords={ totalRecords }
              initialPage={ currentPage }
              setPageLimit={ this.setPageLimit }
              pageLimit={ this.state.pageLimit }
              updateActiveQuery={ this.updateActiveQuery }
            />
          </div>
        </div>
      </Fragment>
    );
  }
}
export default TeamBroadcast;
